/* global jQuery, elementorFrontend */

jQuery( window ).on( 'elementor/frontend/init', () => {

	/**
	* MTD Slider
	* Set up swiper.js instance for the MTD Slider widget
	*
	* @param $element The widget wrapper element as a jQuery element
	* @param $ The jQuery alias
	*/
	const mtdSliderHandler = ( $element, $ ) => {
		const asyncSwiper = elementorFrontend.utils.swiper;
		$element.find('.mtd-slider__slider').each(function() {
			let $this = $(this);
			let slideCount = $this.find('.slide-entry-container').length;

			if( slideCount >= 1 ) {
				let dataID = $element.data('id');
				let columnCount = $this.data('columncount');
				let slideVisibility = $this.data('slidevisibility');

				let centeredSlides, slidesPerViewAddon;

				if( slideVisibility == 'normal' ) {
					centeredSlides = false;
					slidesPerViewAddon = 0;
				} else if( slideVisibility == 'partial' ) {
					centeredSlides = false;
					slidesPerViewAddon = .3;
				} else if( slideVisibility == 'partialcentered' ) {
					centeredSlides = true;
					slidesPerViewAddon = .3;
				}

				var swiperSettings = {
					allowTouchMove: true,
					centeredSlides: centeredSlides,
					// centerInsufficientSlides: true,
					loop: false,
					slidesPerView: 1,
					spaceBetween: 32,
					speed: 350,
					navigation: {
						nextEl: $element.find('.mtd-slider__next')[0],
						prevEl: $element.find('.mtd-slider__prev')[0]
					},
					watchOverflow: true,
					breakpoints: {
						481: {
							// allowTouchMove: false,
							preventClicks: false,
							preventClicksPropagation: false,
							preventInteractionOnTransition: true,
							slidesPerView: Math.max( (columnCount - 2), 1),
							spaceBetween: 24
						},
						768: {
							// allowTouchMove: false,
							preventClicks: false,
							preventClicksPropagation: false,
							preventInteractionOnTransition: true,
							slidesPerView: Math.max( (columnCount - 1), 1) + slidesPerViewAddon,
							spaceBetween: 24
						},
						980: {
							// allowTouchMove: true,
							preventClicks: false,
							preventClicksPropagation: false,
							preventInteractionOnTransition: true,
							slidesPerView: columnCount  + slidesPerViewAddon,
							spaceBetween: 24
						}
					},
					pagination: {
						clickable: true,
						el: $element.find('.mtd-slider__pagination')[0],
						type: 'bullets'
					}
				};

				window["mtdSwiper_"+dataID] = new asyncSwiper($this, swiperSettings);
			}
		});
	};

	elementorFrontend.hooks.addAction( 'frontend/element_ready/mtd-slider.default', mtdSliderHandler );



	/**
	 * MTD Accordion Menu
	 *
	 * @param $element The widget wrapper element as a jQuery element
	 * @param $ The jQuery alias
	 */
	let mmHasChildren = jQuery('.accordionmenu .menu-item-has-children');
	let mmToggleButton = jQuery('<button class="js-mm-toggle"></button>');
	mmHasChildren.append(mmToggleButton);
	const mtdAccordionMenuHandler = ( $element, $ ) => {
		$element.find('.menu-item-has-children > .js-mm-toggle').click(function(e){
			e.preventDefault();


			let $this = $(this);
			$this.parent().toggleClass('open');
		});
	};

	elementorFrontend.hooks.addAction( 'frontend/element_ready/mtd-accordionmenu.default', mtdAccordionMenuHandler );


} );
